"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndividualGroupingRule = void 0;
const HierarchicalNetGroup_1 = require("./HierarchicalNetGroup");
const NetNamingRules_1 = require("./NetNamingRules");
class IndividualGroupingRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Group;
    }
    apply(manager, hierarchy) {
        this.addGroupPerNet(manager, hierarchy);
        return manager;
    }
    addGroupPerNet(manager, hierarchy) {
        try {
            hierarchy.combobulator.getFinalizedNets();
        }
        catch (error) {
            hierarchy.combobulator.computeNets();
        }
        for (const net of hierarchy.combobulator.getFinalizedNets().values()) {
            const group = new HierarchicalNetGroup_1.HierarchicalNetGroup();
            group.addNet(hierarchy.instance, net);
            manager.addGroup(group);
        }
        for (const child of hierarchy.children) {
            this.addGroupPerNet(manager, child);
        }
    }
}
exports.IndividualGroupingRule = IndividualGroupingRule;
//# sourceMappingURL=IndividualGroupingRule.js.map